import { IMemberInfo } from "../store/member";

export interface IConference {
  id?: number;
  timestamp?: Date;
  number: string;
  name: string;
  data: IConferenceData;
}

export interface IConferenceData {
  conferenceDetails?: IConferenceDetails;
  registrationOptions?: IRegistrationOption[];
  pageCards?: IPageCard[];
}

export interface IConferenceDetails {
  location?: string;
  startDate?: Date;
  endDate?: Date;
  registrationFeeSchedule?:IRegistrationFeeOption[]; 
  registrationFee?: number;
  registrationDeadline?: Date;
  lateRegistrationFee?: number;
  lateRegistrationDeadline?:Date;
  abstractSubmissionLink?: string;
  abstractSubmissionDeadline?: Date;
  programTopics?: string[];
  lodging?:string;

  
}

export interface IPageCard{
  title:string;
  content:string; // html
  actions?:IPageCardAction[];
}

export interface IPageCardAction{
  title:string;
  link:string;
  primary?:boolean;
}

export interface IRegistrationFeeOption{
  status:"Members" | "Non-Members" | "Students" | "Retired" | "All";
  deadline: Date;
  fee: number;
}

// const registrationFeeSchedule: IRegistrationFeeOption[] = [
//   {
//     status:"Members",
//     deadline: new Date("2025-04-30"),
//     fee: 50
//   },
//   {
//     status:"Non-Members",
//     deadline: new Date("2025-04-30"),
//     fee: 75
//   },
//   {
//     status: "All",
//     deadline: new Date("2025-05-20"),
//     fee: 95
//   }
// ]

export enum RegistrationOptionType {
  text,
  boolean,
  value,
  choice,
  choiceDetails,
  choiceMultiselect
}

export interface IRegistrationOption {
  optionType: RegistrationOptionType;
  name: string;
  options?: string[] | {main:string,details:string}[];
  value?: string | boolean | number | string[];
  value2?: string | boolean | number;
  public: boolean;
}

export interface IConferenceAttendee extends Omit<IMemberInfo, "username1" | "emailconsent"> {
  timestamp?: Date;
  memberId?: number;
  confirmationCode: string;
  conferenceId: number;
  details?: string | IRegistrationOption[];
  payby?: string;
  due?: number;

  updateFromIMemberInfo(memberinfo: IMemberInfo): void;
}

// interface IConferenceAttendeeExtra{
//     name:string;
//     value:string;
// }

export class ConferenceAttendee implements IConferenceAttendee {
  acs: boolean = false;
  divc: boolean = false;
  teacher: string = "";
  first: string = "";
  last: string = "";
  institution: string = "";
  addr1: string = "";
  addr2: string = "";
  city: string = "";
  st: string = "";
  zip: string = "";
  phone: string = "";
  email: string = "";
  weblist: boolean = false;
  other: string = "";
  conferenceId: number = -1;
  confirmationCode: string = "";
  memberId?: number = -1;

  updateFromIMemberInfo(memberinfo: IMemberInfo) {
    this.acs = memberinfo.acs;
    this.addr1 = memberinfo.addr1;
    this.addr2 = memberinfo.addr2;
    this.city = memberinfo.city;
    this.divc = memberinfo.divc;
    this.email = memberinfo.email;
    this.first = memberinfo.first;
    this.institution = memberinfo.institution;
    this.last = memberinfo.last;
    this.memberId = memberinfo.id; // critical
    this.other = memberinfo.other;
    this.phone = memberinfo.phone;
    this.st = memberinfo.st;
    this.teacher = memberinfo.teacher;
    this.weblist = memberinfo.weblist;
    this.zip = memberinfo.zip;
  }

  static fromIMemberInfo(memberinfo: IMemberInfo): IConferenceAttendee {
    const attendee: IConferenceAttendee = new ConferenceAttendee();
    attendee.acs = memberinfo.acs;
    attendee.addr1 = memberinfo.addr1;
    attendee.addr2 = memberinfo.addr2;
    attendee.city = memberinfo.city;
    attendee.divc = memberinfo.divc;
    attendee.email = memberinfo.email;
    attendee.first = memberinfo.first;
    attendee.institution = memberinfo.institution;
    attendee.last = memberinfo.last;
    attendee.memberId = memberinfo.id; // critical
    attendee.other = memberinfo.other;
    attendee.phone = memberinfo.phone;
    attendee.st = memberinfo.st;
    attendee.teacher = memberinfo.teacher;
    attendee.weblist = memberinfo.weblist;
    attendee.zip = memberinfo.zip;
    return attendee;
  }

  static setupDetails(
    attendee: IConferenceAttendee,
    conferenceData: IConferenceData
  ) {
    const details: IRegistrationOption[] = [];
    if (conferenceData.registrationOptions) {
      conferenceData.registrationOptions
        .filter((x) => x.public)
        .forEach((option) => {
          details.push(option);
        });
    }
    if (attendee.details) {
      // attendee already has details, check if any are missing and add them, otherwise leave it alone
      for (const prop of details) {
        const attendeeRegistrationOptions =
          attendee.details as IRegistrationOption[];
        if (attendeeRegistrationOptions && attendeeRegistrationOptions.find) {
          if (!attendeeRegistrationOptions.find((x) => x.name === prop.name)) {
            attendeeRegistrationOptions.push(prop);
          }
        }
      }
    } else {
      attendee.details = details;
    }
  }
}

// CAN DELETE BELOW... JUST TESTING
// const registrationOptions: IRegistrationOption[] = [
//   {
//     name: "Meal Preference",
//     optionType: RegistrationOptionType.choice,
//     public: true,
//     options: ["Regular", "Vegetarian", "Vegan"],
//     value: "Regular",
//   },
//   {
//     name: "Attendance Friday",
//     optionType: RegistrationOptionType.boolean,
//     public: false,
//     value: false,
//   },
//   {
//     name: "Friday Lunch",
//     optionType: RegistrationOptionType.boolean,
//     public: true,
//     value: false,
//   },
//   {
//     name: "Friday Dinner",
//     optionType: RegistrationOptionType.boolean,
//     public: true,
//     value: false,
//   },
//   {
//     name: "Attendance Saturday",
//     optionType: RegistrationOptionType.boolean,
//     public: false,
//     value: false,
//   },
//   {
//     name: "Saturday Lunch",
//     optionType: RegistrationOptionType.boolean,
//     public: true,
//     value: false,
//   },
//   {
//     name: "Saturday Dinner",
//     optionType: RegistrationOptionType.boolean,
//     public: true,
//     value: false,
//   },
// ];

// // const conference: IConference = {
// //   id: 1,
// //   name: "Using High Impact Practices to Empower Chemistry Students",
// //   number: "225th",
// //   data: {
// //     registrationOptions: registrationOptions,
// //   },
// // };
